import React, { useState, useRef, useEffect } from 'react';
import imgPlaceholder from '../Group 1755741347.svg';
import upload from '../Vector.svg';
import ToastError from '../../Toasts/ToastError';
import { ButtonBlue, ButtonLightGrey } from '../../HouseStyle/Components/Buttons';

const Step3LogoColor = ({ data, updateData, onNext, onPrev, onLogoUpload }) => {
    const [formData, setFormData] = useState({
        logo: data.logo || null,
        blackwhite_logo: data.blackwhite_logo || null,
        phone_number_country_code: data.phone_number_country_code || '',
        phone_number: data.phone_number || ''
    });

    const colorLogoInputRef = useRef(null);
    const bwLogoInputRef = useRef(null);

    useEffect(() => {
        setFormData({
            logo: data.logo || null,
            blackwhite_logo: data.blackwhite_logo || null,
            phone_number_country_code: data.phone_number_country_code || '',
            phone_number: data.phone_number || ''
        });
    }, [data]);

    const handleLogoUpload = (file, type) => {
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/svg+xml'];
        if (!file || !allowedTypes.includes(file.type)) {
            ToastError('Selecteer een geldig afbeeldingsbestand (JPEG, PNG, GIF of SVG)');
            return;
        }
        if (onLogoUpload) {
            onLogoUpload(file, type);
            const reader = new FileReader();
            reader.onload = (e) => {
                setFormData(prev => ({
                    ...prev,
                    [type]: e.target.result // Store base64 string directly
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleColorLogoClick = () => {
        colorLogoInputRef.current?.click();
    };

    const handleBWLogoClick = () => {
        bwLogoInputRef.current?.click();
    };

    const handleNext = () => {
        onNext();
    };

    const handlePrev = () => {
        onPrev();
    };

    const handleSkip = () => {
        onNext();
    };

    return (
        <div className="step-container">
            <div className="step-content-area">
                <div className="step-form">
                    <h2 className="step-title">Bedrijfslogo & Kleuren</h2>
                    {/* Color Logo Section */}
                    <div className="logo-section">
                        <div className="row col-md-12">
                            <div className="col-md-7">
                                <h4>Upload bedrijfslogo</h4>
                                <div className="logo-upload-area" onClick={handleColorLogoClick}>
                                    <label>
                                        <img src={upload} alt="Upload" className="upload-icon" />
                                        <input
                                            ref={colorLogoInputRef}
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleLogoUpload(e.target.files[0], 'logo')}
                                            style={{ display: 'none' }}
                                        />
                                    </label>
                                </div>
                                <p>
                                    Het logo dat je hier instelt, zal worden gebruikt in het systeem.
                                    Je ziet het dus op verschillende plekken terug, zoals in overzichten
                                    en communicatie. Zo zorgen we ervoor dat het geheel persoonlijker en
                                    beter herkenbaar is voor jou en je klanten.
                                </p>
                            </div>
                            <div className="col-md-5">
                                <h4>Voorbeeld bedrijfslogo kleur</h4>
                                <div className="logo-preview mw-100">
                                    {formData.logo ? (
                                        <img
                                            src={formData.logo}
                                            alt="Logo preview"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain'
                                            }}
                                        />
                                    ) : (
                                        <div className="logo-placeholder">
                                            <img
                                                src={imgPlaceholder}
                                                alt="Logo preview"
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '100%',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Black & White Logo Section */}
                    <div className="row col-md-12">
                        <div className="col-md-7">
                            <h3>bedrijfslogo zwart met transparante achtergrond</h3>
                            <div className="logo-upload-area" onClick={handleBWLogoClick}>
                                <label>
                                    <img src={upload} alt="Upload" className="upload-icon" />
                                    <input
                                        ref={bwLogoInputRef}
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => handleLogoUpload(e.target.files[0], 'blackwhite_logo')}
                                        style={{ display: 'none' }}
                                    />
                                </label>
                            </div>
                            <p>
                                Dit logo wordt gebruikt voor de bonprinter en op 
                                facturen. Omdat deze vaak geen kleuren 
                                ondersteunen, zorgen we met dit logo voor een 
                                duidelijke en professionele weergave van jouw 
                                winkel in alle zwart-wit afdrukken.
                            </p>
                        </div>
                        <div className="col-md-5 logo-upload-container">
                            <h4>Voorbeeld bedrijfslogo (zwart/wit)</h4>
                            <div className="logo-preview mw-100">
                                {formData.blackwhite_logo ? (
                                    <img
                                        src={formData.blackwhite_logo}
                                        alt="Logo zwart/wit preview"
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            objectFit: 'contain'
                                        }}
                                    />
                                ) : (
                                    <div className="logo-placeholder">
                                        <img
                                            src={imgPlaceholder}
                                            alt="Logo zwart/wit preview"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain'
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-actions">
                <ButtonLightGrey
                    onClickFunction={handleSkip}
                    text="Overslaan"
                />
                <ButtonLightGrey
                    onClickFunction={handlePrev}
                    text="Terug"
                />
                <ButtonBlue
                    onClickFunction={handleNext}
                    text="Verder"
                />
            </div>
        </div>
    );
};

export default Step3LogoColor;